/**
 * "Read more" for the long-form collection copy.
 *
 * The clamp is applied by JS, never by CSS alone: if the script fails the copy must stay
 * fully readable rather than truncated with no way to expand it. The button is only revealed
 * when the text actually overflows the clamp, so short descriptions get no control.
 */
(() => {
  const init = (info) => {
    const body = info.querySelector('.cl-info__body');
    const button = info.querySelector('.cl-info__more');
    if (!body || !button) return;

    const setLabel = (expanded) => {
      button.textContent = expanded ? button.dataset.less : button.dataset.more;
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    };

    const apply = () => {
      // Measure unclamped, then clamp. The clamp uses `overflow: clip`, which creates no
      // scroll container, so scrollHeight equals clientHeight once it is applied — comparing
      // them after the fact would report no overflow and the button would never appear.
      info.classList.remove('is-expanded', 'cl-info--clamped');
      setLabel(false);
      const full = body.scrollHeight;

      info.classList.add('cl-info--clamped');
      const overflows = full - body.clientHeight > 2;

      button.hidden = !overflows;
      if (!overflows) info.classList.remove('cl-info--clamped');
    };

    button.addEventListener('click', () => {
      setLabel(info.classList.toggle('is-expanded'));
    });

    apply();

    let timer;
    window.addEventListener('resize', () => {
      clearTimeout(timer);
      timer = setTimeout(apply, 150);
    });
  };

  document.querySelectorAll('.cl-info[data-read-more]').forEach(init);
})();
